import { n as h } from "../../query-assigned-elements.57643bdd.js";
import { L as o } from "../../leaf-element.4609dd44.js";
var p = Object.defineProperty, d = Object.getOwnPropertyDescriptor, f = (a, e, s, i) => {
  for (var t = i > 1 ? void 0 : i ? d(e, s) : e, l = a.length - 1, r; l >= 0; l--)
    (r = a[l]) && (t = (i ? r(e, s, t) : r(t)) || t);
  return i && t && p(e, s, t), t;
};
class u extends o {
  constructor() {
    super(), this.internals = this.attachInternals();
  }
  get value() {
    return this.internalValue;
  }
  set value(e) {
    const s = this.value;
    this.internalValue = e, this.type !== "checkbox" && this.type !== "radio" && this.internals.setFormValue(e), this.updateField(), this.requestUpdate("value", s);
  }
  updateField() {
    this.field && (this.field.value = this.value !== void 0 ? this.value : "");
  }
  firstUpdated() {
    this.type !== "checkbox" && this.type !== "radio" && (this.defaultValue = this.value || this.getAttribute("value") || ""), this.updateField();
  }
  formResetCallback() {
    this.value = this.defaultValue, this.updateField();
  }
}
u.formAssociated = !0;
f([h()], u.prototype, "value", 1);
export {
  u as LeafFormElement,
  u as default
};
